// extracted by mini-css-extract-plugin
var _1 = "AuthenticationSettings_action__mZdM-";
var _2 = "AuthenticationSettings_actionsWrapper__a2OPq";
export { _1 as "action", _2 as "actionsWrapper" }
